module.exports = __webpack_public_path__ + "static/img/study.9991621.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/community/study.png
// module id = X2Hn
// module chunks = 0